<!-- [breakpoints]="{ '1080px': '80vw', '560px':'80vw' }" -->
<ng-container *transloco="let t;">
    <p-dialog [header]="t('maintenance.newVersionTitle')" [(visible)]="isDialogRefreshOpen" (onHide)="onCloseDialog()"
        [style]="{maxWidth: '600px' }" class="new-version-modal" [modal]="true">
        <div class="flex flex-col">
            <span
                class="text-center sm:text-start px-5 text-xl font-bold font-space whitespace-pre-line">{{t('maintenance.newVersionAvailable')}}</span>
            <br>

            <!-- CHANGELOG -->
            <div *ngIf="true" class="changelog my-7">
                <!-- <div class="my-3 w-1/2 mx-auto">
                    <k-divider forceHeight="3px"></k-divider>
                </div> -->
                <!-- <div class="gradient-text"> -->

                <span class="px-5 text-xl font-nikkyou font-bold">{{t('maintenance.whatsNews')}}</span>
                <!-- </div> -->
                <div class="list flex flex-nowrap items-center pl-4 my-2">
                    <!-- <div class="bg-gradient-to-r from-k-pink to-k-purple w-2 h-2 rounded-full mr-3"></div> -->
                    <div class="bg-k-pink w-2 h-2 rounded-full mr-3">

                    </div>
                    <div class="gradient-text">
                        <span
                            class="text-start text-xl italic font-bold font-space pr-5">{{t('maintenance.newBreeding')}}</span>
                    </div>
                </div>

                <!-- <div class="my-3 w-1/2 mx-auto">
                    <k-divider forceHeight="3px"></k-divider>
                </div> -->
            </div>
            <!-- CHANGELOG -->
            <span
                class="text-center px-5 text-xl font-bold font-space whitespace-pre-line my-10">{{t('maintenance.refreshToDownload')}}</span>
            <div class="ml-auto  my-2">
                <k-button (onClickAction)="onConfirmRefresh()" [label]="t('shared.refresh')"></k-button>
            </div>
        </div>
    </p-dialog>
</ng-container>